import { isBefore, subMinutes } from 'date-fns';

import { clearCookies } from './CookieUtils';
import { getLogoutRedirectUrl } from './UrlUtil';

const isBase64Url = (str) => /^[A-Za-z0-9_-]+$/.test(str);

const parseJwt = (token) => {
  try {
    const base64Url = token.split('.')[1];
    if (!base64Url) return null;

    let base64 = base64Url;
    if (isBase64Url(base64Url)) {
      base64 =
        base64Url.replace(/-/g, '+').replace(/_/g, '/') +
        '=='.substring(0, (3 * base64Url.length) % 4);
    }
    const decodedJwt = JSON.parse(atob(base64));

    return decodedJwt;
  } catch (error) {
    console.error('Error parsing JWT:', error);
    return null;
  }
};
export const isTokenExpired = (token) => {
  if (!token) return true;
  const decodedJwt = parseJwt(token);
  return decodedJwt.exp * 1000 < Date.now();
};

export const parseAccessToken = (hash) => {
  const TokenRegex = /\b(\w+|-)\.(\w+|-).\.(\w+|-)+/;
  const accessAndIdToken = TokenRegex.exec(hash);
  if (!accessAndIdToken) {
    return '';
  }
  return accessAndIdToken[0];
};

const REDIRECT_STORAGE_KEY = 'redirect-efix-custom';

const getRedirect = () => localStorage.getItem(REDIRECT_STORAGE_KEY);

const setRedirect = () => {
  localStorage.setItem(
    REDIRECT_STORAGE_KEY,
    JSON.stringify({
      timestamp: new Date().toISOString(),
      pathname: window.location.pathname,
    })
  );
};

const removeRedirect = () => {
  localStorage.removeItem(REDIRECT_STORAGE_KEY);
};

export const REDIRECT_NOTE_SEARCH_KEY = 'redirectFrom';

const setRedirectSearchNote = (params, redirectedFrom) => {
  params.set(REDIRECT_NOTE_SEARCH_KEY, redirectedFrom);
};

export const tryRedirect = () => {
  const storageRedirect = getRedirect();

  if (!storageRedirect) return;

  removeRedirect();
  try {
    const parsedStorageRedirect = JSON.parse(storageRedirect);

    const timestamp = new Date(parsedStorageRedirect.timestamp);

    // allow max two minutes
    const invalidRedirect = isBefore(timestamp, subMinutes(new Date(), 2));

    if (invalidRedirect) return;

    const pathToRedirect = parsedStorageRedirect.pathname;

    if (!pathToRedirect.startsWith('/')) return;

    if (window.location.pathname === pathToRedirect) {
      return;
    }

    const replaceUrl = new URL(window.location);

    setRedirectSearchNote(replaceUrl.searchParams, replaceUrl.pathname);
    replaceUrl.pathname = pathToRedirect;

    window.location.replace(replaceUrl);
  } catch (e) {
    console.error('Redirect failed', e);
  }
};

export const logoutWithRedirect = (isCIAM) => {
  localStorage.clear();
  clearCookies();
  setRedirect();
  window.location.href = getLogoutRedirectUrl(isCIAM);
};
